var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.existingCallerFoundDialogVisible, width: "50%" },
      on: {
        "update:visible": function ($event) {
          _vm.existingCallerFoundDialogVisible = $event
        },
      },
    },
    [
      _c(
        "span",
        { attrs: { slot: "title" }, slot: "title" },
        [
          _c("svg-icon", { attrs: { "icon-class": "phone-call" } }),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _c("span", [_vm._v("Incoming Call from Existing Client")]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.existingCallerTableData,
            border: "",
            "show-header": false,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "attribute", label: "Attribute", width: "180" },
          }),
          _c("el-table-column", { attrs: { prop: "value", label: "Value" } }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.populateForm } },
            [_vm._v("OK")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }